module.exports = __webpack_public_path__ + "static/media/Asset1.403c6691.png";